﻿import { Plugin, DialogViewPosition } from 'ckeditor5';

export default class SpecialCharactersPositioning extends Plugin{

    static get pluginName() { return "SpecialCharactersPositioning" };

    init() {
        const editor = this.editor;
        // Set default width
        editor.plugins.get('Dialog').on('show:specialCharacters', (evt, data) => {
            Object.assign(data, { position: DialogViewPosition.SCREEN_CENTER });
        }, { priority: 'high' });
    }
}